import { format } from "date-fns";

export const mapItemsPerPageSelect = () => {
    return [5, 10, 15, 20].map((opt, i) => {
        return {
            id: i,
            available: true,
            value: opt
        };
    });
};

const statusMap = {
    DELIVERED: "Delivered",
    COMPLETED: "Completed",
    IN_TRANSIT: "In transit",
    ORDER_RECEIVED: "Order received",
};

export const mapStatusTagStyles = status => {
    switch (status) {
        case statusMap.DELIVERED:
        case statusMap.ORDER_RECEIVED:
            return {
                dotColor: "#00A76A",
                backgroundColor: "#00A76A26"
            };
        case statusMap.COMPLETED:
            return {
                dotColor: "#217BBE",
                backgroundColor: "#217BBE26"
            };
        case statusMap.IN_TRANSIT:
            return {
                dotColor: "#FF9C00",
                backgroundColor: "#FF9C0026"
            };
        default:
            return {
                dotColor: "#217BBE",
                backgroundColor: "#217BBE26"
            };
    }
};

export const formatedPrice = price => {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR"
    }).format(price);
};

export const formatDateDDMMMYYYY = date => format(new Date(date), "dd MMM yyyy");

export const formatDateWithSlash = date => format(new Date(date), "dd/MM/yyyy");

export const getSearchParamsFromUrl = key => new URLSearchParams(window.location.search).get(key);

export const formatOrderNumber = (orderId, length = 7, padChar = '0') => {
    if (!orderId) return '';
    const orderIdStr = orderId.toString();
    return `APS${orderIdStr.padStart(length, padChar)}`;
}

export const transactionsDateFilters = [
    {
        label: "Last 30 days",
        value: "month"
    },
    {
        label: "Last 3 months",
        value: "quarter"
    },
    {
        label: "Last 6 months",
        value: "halfYear"
    },
    {
        label: "Last 12 months",
        value: "year"
    }
];

export const filterOrders = (filters, allOrdersList) => {
    if (!filters || !allOrdersList) return;
    const { productFilter, dateFilter, startDayFilter, endDayFilter } = filters;
    const customFrom = startDayFilter; 
    const customTo = endDayFilter;    
    
    const now = new Date().setHours(0, 0, 0, 0);
    
    const getStartDate = (range) => {
        const date = new Date();
        switch (range) {
        case 'month':
            date.setDate(date.getDate() - 30);
            break;
        case 'quarter':
            date.setMonth(date.getMonth() - 3);
            break;
        case 'halfYear':
            date.setMonth(date.getMonth() - 6);
            break;
        case 'year':
            date.setFullYear(date.getFullYear() - 1);
            break;
        default:
            return null;
        }
        return date;
    };
    
    return allOrdersList.filter((order) => {
        const orderDate = new Date(order.orderDate).setHours(0, 0, 0, 0);
        let isDateMatch = true;
    
        if (dateFilter) {
            const startDate = getStartDate(dateFilter).setHours(0, 0, 0, 0);
            isDateMatch = startDate ? orderDate >= startDate && orderDate <= now : true;
        } else if (customFrom || customTo) {
            const from = customFrom ? new Date(customFrom).setHours(0, 0, 0, 0) : new Date('1970-01-01');
            const to = customTo ? new Date(customTo).setHours(0, 0, 0, 0) : now;
            isDateMatch = orderDate >= from && orderDate <= to;
        }
    
        const matchesProductFilter = productFilter
            ? order.orderItems.some(item => item.productId === productFilter)
            : true;
    
        return isDateMatch && matchesProductFilter;
    });
};
